import {OverlayTrigger, Tooltip} from "react-bootstrap";
import React, {useState} from "react";
import {CaretDownFill, CaretUpFill, ExclamationCircle} from 'react-bootstrap-icons'

function TableHeader({ columns, upTrend, onSort }) {
    const [sortField, setSortField] = useState("");
    const [order, setOrder] = useState("asc");
    const [disabled, setDisabled] = useState(false)

    const handleSortingChange = (accessor) => {
        setDisabled(true)
        const sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
        setSortField(accessor);
        setOrder(sortOrder);
        onSort(accessor, sortOrder);
        setTimeout(() => {
            setDisabled(false); // Set loading to false when the operation is done
        }, 2000);
    }

    const setClassName = (field, sort) => {
        return sortField === field && order === sort ? 'active' : ''
    }
    return (
        <thead className="mb-5 bg-blue">
            <tr className="fw-semibold fs-6 border-bottom-2 mb-5 border-gray-200">
                {columns.map((column, index) => {
                    const onClick = column.sortable && !disabled ? () => handleSortingChange(column.key) : null
                    const tooltip = column.info ?
                        <OverlayTrigger placement="top" overlay={<Tooltip><strong>{column.tooltip}</strong></Tooltip>}>
                            <ExclamationCircle style={{ marginRight: 5 }} />
                        </OverlayTrigger>
                        : null

                    if (upTrend) {
                        return (
                            <th className="text-center" key={index} onClick={onClick}>
                                <div className="d-flex align-items-center justify-content-center">
                                    {column.value}
                                    {tooltip}
                                    {
                                        column.sortable && <span className="sortIcon">
                                            <CaretUpFill className={setClassName(column.key, 'desc')} />
                                            <CaretDownFill className={setClassName(column.key, 'asc')} />
                                        </span>
                                    }

                                </div>
                            </th>
                        )
                    } else {
                        return (
                            column.upTrend &&
                            <th className="text-center" key={index} onClick={onclick}>
                                <div className="d-flex align-items-center justify-content-center">
                                    {column.value}
                                    {tooltip}
                                    {
                                        column.sortable && <span className="sortIcon">
                                            <CaretUpFill className={setClassName(column.key, 'desc')} />
                                            <CaretDownFill className={setClassName(column.key, 'asc')} />
                                        </span>
                                    }
                                </div>
                            </th>

                        )
                    }
                })}
            </tr>
        </thead>
    )
}

export default TableHeader